export const formatChatTimestamp = (timestamp: Date, locale: string): string =>
  timestamp.toLocaleString(locale)
